var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: { "modal-dialog-size": "md" },
    on: {
      hidden: function ($event) {
        return _vm.$emit("hidden")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("templates.modals.sendEmailTitle")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", { staticClass: "justified progress-text" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("templates.modals.sendEmailSubtitle")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("material-input", {
              staticClass: "position-relative",
              attrs: {
                id: "name",
                name: "name",
                "on-type": "",
                label: _vm.$t("global.doorr.emailAddress"),
                type: "email",
              },
              model: {
                value: _vm.emailAddress,
                callback: function ($$v) {
                  _vm.emailAddress = $$v
                },
                expression: "emailAddress",
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  disabled: _vm.$v.$invalid,
                  loading: _vm.loading,
                  "loading-succeeded": _vm.sendSucceeded,
                },
                on: { click: _vm.handleSendEmail },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("global.actions.sendEmail")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }